export const resizeImage = (file, maxWidth, maxHeight) => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.onload = () => {
        let width = img.width
        let height = img.height
        const ratio = Math.min(maxWidth / width, maxHeight / height)

        if (width > maxWidth || height > maxHeight) {
          width = Math.round(width * ratio)
          height = Math.round(height * ratio)

          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)

          canvas.toBlob(blob => {
            const resizedFile = new File([blob], file.name, file)
            resolve(resizedFile)
          }, file.type, 1)
        }
        else resolve(file)
      }
      img.src = event.target.result
    }
    reader.readAsDataURL(file)
  })
}